// Global JavaScript - Performance optimized, vanilla JS
(function() {
  'use strict';

  // Feature detection
  const supportsIntersectionObserver = 'IntersectionObserver' in window;
  const supportsWebP = document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') === 0;

  // Lazy loading for images
  if (supportsIntersectionObserver) {
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          img.src = img.dataset.src;
          img.classList.remove('lazy');
          observer.unobserve(img);
        }
      });
    }, {
      rootMargin: '50px 0px',
      threshold: 0.01
    });

    document.addEventListener('DOMContentLoaded', () => {
      const lazyImages = document.querySelectorAll('img.lazy');
      lazyImages.forEach(img => imageObserver.observe(img));
    });
  }

  // Cart API helpers
  window.ShopifyCart = {
    addItem: function(variantId, quantity = 1) {
      return fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity
        })
      })
      .then(response => response.json())
      .catch(err => console.error('Error adding to cart:', err));
    },

    updateQuantity: function(key, quantity) {
      return fetch(window.routes.cart_change_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: key,
          quantity: quantity
        })
      })
      .then(response => response.json());
    },

    getCart: function() {
      return fetch('/cart.js')
        .then(response => response.json());
    }
  };

  // Debounce utility
  window.debounce = function(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  };

  // Focus management for accessibility
  window.focusTarget = function(target) {
    const element = document.querySelector(target);
    if (!element) return;
    
    element.focus();
    if (document.activeElement !== element) {
      element.setAttribute('tabindex', '-1');
      element.focus();
    }
  };

  // Performance monitoring
  if ('PerformanceObserver' in window) {
    try {
      const perfObserver = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          // Log to console in development
          if (window.location.hostname === 'localhost') {
            console.log(`${entry.name}: ${entry.startTime.toFixed(2)}ms`);
          }
        }
      });
      perfObserver.observe({ entryTypes: ['largest-contentful-paint', 'first-input', 'layout-shift'] });
    } catch (e) {
      // PerformanceObserver not supported
    }
  }

  // Initialize
  document.addEventListener('DOMContentLoaded', function() {
    // Add WebP support class
    if (supportsWebP) {
      document.documentElement.classList.add('webp');
    }

    // Prevent FOUC
    document.documentElement.style.visibility = 'visible';
  });

})();